import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { AccountResponse, AccountVM } from "../models/account-view.model";
import { Observable } from "rxjs/Observable";
import { FileUpload } from "../models/file-upload";
import { NameId } from "../models/nameId";
import { AccountBulkEditViewModel } from "../models/account-bulk-edit-view.model";
import { HttpClient } from "@angular/common/http";

const URL = environment.apiBaseUrl;

@Injectable()
export class AccountService {
  constructor(private http: HttpClient) {}

  public accounts(
    startRow: number,
    endRow: number,
    searchText: string,
    sortCol: string,
    sortDesc: boolean
  ): Observable<AccountResponse> {
    const url =
      `${URL}accounts?startRow=${startRow}&endRow=${endRow}&searchString=${searchText}` +
      `&sortColumn=${sortCol}&sortDescending=${sortDesc}`;

    return this.http.get<AccountResponse>(url).map((x: any) => {
      const res: AccountResponse = {
        accounts: x.data as AccountVM[],
        total: x.total
      };
      return res;
    });
  }

  public getAccount(id: string): Observable<AccountVM> {
    return this.http.get<AccountVM>(`${URL}accounts/${id}`);
  }

  public updateAccount(account: AccountVM): Observable<string> {
    return this.http.put<string>(`${URL}accounts`, account);
  }

  public addAccount(account: AccountVM) {
    return this.http.post(`${URL}accounts`, account);
  }

  public deleteAccount(id: number) {
    return this.http.delete(`${URL}accounts/delete/${id}`);
  }

  public importFile(fileUpload: FileUpload) {
    return this.http.post(`${URL}accounts/import`, fileUpload);
  }

  public getAllSimpleAdvisorList(): Observable<NameId[]> {
    return this.http.get<NameId[]>(`${URL}/CoProducerAgreements/advisorList`);
  }

  public recalculateAccountsForOpenQuarter() {
    return this.http.post(
      `${URL}/accounts/recalculateAcccountsForCurrentQuarter`,
      null
    );
  }

  public bulkUpdate(accountIds: number[], vm: AccountBulkEditViewModel) {
    return this.http.post(`${URL}accounts/bulkUpdate`, {
      accountIds: accountIds,
      bulkUpdate: vm
    });
  }
}
